import { render, staticRenderFns } from "./customercount.vue?vue&type=template&id=fd6165c6&scoped=true"
import script from "./customercount.vue?vue&type=script&lang=js"
export * from "./customercount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6165c6",
  null
  
)

export default component.exports